// extracted by mini-css-extract-plugin
export default {"main-text":"Alert_main-text__hB7KW","mainText":"Alert_main-text__hB7KW","button-text":"Alert_button-text__Cx5g3","buttonText":"Alert_button-text__Cx5g3","paper":"Alert_paper__sjhaO"};